import axios from "axios";
import { apiEndpoint } from "@iso/lib/helpers/endpoint";
import { authHeader } from "@iso/lib/helpers/authHeader";

// Defects against an asset (Phase 3). Raising is allowed for any property member;
// status changes/deletes are gated to owner/admin/safety server-side.
export const defectService = {
  getList,
  create,
  updateStatus,
  destroy,
};

function getList(facilityId, status = null) {
  const params = { facility_id: facilityId };
  if (status) params.status = status;
  return axios
    .get(`${apiEndpoint.defects}`, { headers: authHeader(), params })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

function create(payload) {
  return axios
    .post(`${apiEndpoint.defects}`, payload, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

function updateStatus(id, status) {
  return axios
    .put(`${apiEndpoint.defects}/${id}/status`, { status }, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

function destroy(id) {
  return axios
    .delete(`${apiEndpoint.defects}/${id}`, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}
